import React, { Component, Fragment } from "react";
import { Menu, Popup, Button, Icon } from "semantic-ui-react";
import { PropTypes } from "prop-types";
import CustomFieldConfirmModal from '../../Pages/CustomFields/CustomFieldConfirmModal';

class SubHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeItem: "Staff Linking",
            showClose: this.props.showClose
        };
    }

    handleItemClick = (e, { name }) => this.setState({ activeItem: name });

    render() {
        const { activeItem } = this.state.activeItem;
        const activeStyle = 'color-wk-primary-blue font-weight: bold active';
        if (this.props.subHeaderMenuItems) {
            const subHeaderList = this.props.subHeaderMenuItems.map(item => {
                return (
                    <Menu.Item
                        key={item.name}
                        name={item.name}
                        active={activeItem === item.name}
                        onClick={this.handleItemClick}
                        className={this.state.activeItem === item.name ? activeStyle : ""}
                        style={{ display: item.name === "Client Linking" ? 'none' : 'block' }}
                    />
                );
            });

            return (
                <Fragment>
                    <Menu className='sub' pointing secondary>
                        {subHeaderList}

                        <Menu.Menu position="right">
                            {this.state.showClose ?
                                <CustomFieldConfirmModal />
                                : ""
                            }

                        </Menu.Menu>
                    </Menu>
                </Fragment>
            );
        } else {
            return (
                <div>
                    <h2>Sub Header module is'nt working properly</h2>
                </div>
            );
        }
    }
}

SubHeader.propTypes = {
    subHeaderMenuItems: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            url: PropTypes.string
        })
    )
};

export default SubHeader;
